// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import BankListController from "./bank_list_controller"
application.register("bank-list", BankListController)

import BeneficiariesController from "./beneficiaries_controller"
application.register("beneficiaries", BeneficiariesController)

import ConsentModalController from "./consent_modal_controller"
application.register("consent-modal", ConsentModalController)

import FlashMessageController from "./flash_message_controller"
application.register("flash-message", FlashMessageController)

import FlutterwaveController from "./flutterwave_controller"
application.register("flutterwave", FlutterwaveController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import LeadModalController from "./lead_modal_controller"
application.register("lead-modal", LeadModalController)

import PasswordToggleController from "./password_toggle_controller"
application.register("password-toggle", PasswordToggleController)

import PwaInstallController from "./pwa_install_controller"
application.register("pwa-install", PwaInstallController)

import WithdrawalFormController from "./withdrawal_form_controller"
application.register("withdrawal-form", WithdrawalFormController)
